import { render, staticRenderFns } from "./EditText.vue?vue&type=template&id=452425ca&scoped=true&"
import script from "./EditText.vue?vue&type=script&lang=js&"
export * from "./EditText.vue?vue&type=script&lang=js&"
import style0 from "./EditText.vue?vue&type=style&index=0&id=452425ca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452425ca",
  null
  
)

export default component.exports